/**
 * @generated SignedSource<<94ef63130a791337950ecf07c758f57e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GuestMembershipsOrderBy = "joined_on" | "member_name" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type CreateGuestMembershipCSVDataInput = {
  direction?: OrderDirection | null;
  hasBeenInvited?: boolean | null;
  orderBy?: GuestMembershipsOrderBy | null;
  organizationId: string;
  search?: string | null;
};
export type CommunityGuestReportTableMutation$variables = {
  input: CreateGuestMembershipCSVDataInput;
};
export type CommunityGuestReportTableMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type CommunityGuestReportTableMutation = {
  response: CommunityGuestReportTableMutation$data;
  variables: CommunityGuestReportTableMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGuestMembershipCSVDataResponse",
    "kind": "LinkedField",
    "name": "createGuestMembershipCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunityGuestReportTableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommunityGuestReportTableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "428f934fc71fc2aae501735b57a3a0e5",
    "id": null,
    "metadata": {},
    "name": "CommunityGuestReportTableMutation",
    "operationKind": "mutation",
    "text": "mutation CommunityGuestReportTableMutation(\n  $input: CreateGuestMembershipCSVDataInput!\n) {\n  response: createGuestMembershipCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d9312fc2c5b20b7059fcaafeebe82a9";

export default node;
